module.exports = __webpack_public_path__ + "static/media/alert-purple.6a1ffd8a.png";